import { SupportMessageTags } from '@website/types/graphqlOperations';
import { useEffect, useState } from 'react';
import HelpButton from '../../HelpButton';
import ContactForm from '../contactForm/ContactForm';

type Props = {
  tripTitle?: string;
};

export default function NewTrip({ tripTitle }: Props) {
  const [currentActiveKey, setActiveKey] = useState<string>();
  const buttonProps = { currentActiveKey, setActiveKey };

  useEffect(() => {
    if (tripTitle) {
      setActiveKey('yes');
    }
  }, [tripTitle]);

  return (
    <div className="mt-3">
      <h2 className="h4">Do you know which trip you're interested in?</h2>

      <HelpButton {...buttonProps} activeKey="yes" text="Yes">
        <ContactForm
          defaultSubject={tripTitle}
          tags={[SupportMessageTags.PRE_TRIP_QUESTION]}
          subjectLabel="What trip are you interested in?"
        />
      </HelpButton>

      <HelpButton {...buttonProps} activeKey="no" text="I'm trying to decide">
        <p>
          Let us know what trip or information you're looking for and we'd be
          happy to help.
        </p>
        <ContactForm
          defaultSubject="Trying to decide which trip"
          tags={[SupportMessageTags.TRIP_RECOMMENDATION]}
          messagePlaceholder={"I'm trying to decide"}
        />
      </HelpButton>
    </div>
  );
}
